import React from "react";
import HubShell from "../../Components/Common/HubShell";
import AppMetrics from "../AppMetrics";
import AppAlerts from "../Alerts";

document.title = "Growth | BiorGov Admin";

// App install/usage metrics + the in-app price alerts users set (an engagement
// signal, hence Growth rather than Operations).
const TABS = [
  { id: "app-metrics", label: "App Metrics",  icon: "ri-smartphone-line",    perm: "app_metrics.view", render: () => <AppMetrics embedded /> },
  { id: "alerts",      label: "Price Alerts", icon: "ri-alarm-warning-line", perm: "alerts.view",      render: () => <AppAlerts embedded /> },
];

const Growth = () => <HubShell title="Growth" pageTitle="Acquisition" tabs={TABS} />;

export default Growth;
